/**
 * Global alert helper for the app.
 * All user-facing success/error messages (validation, API errors) should go through
 * this module so they use the same component (sonner Toaster) in the same way.
 */

import { toast } from 'sonner@2.0.3';

export type AlertOptions = {
  /** A button in the message, e.g. "Open in new tab". Its click is a fresh user action, so it may open a tab. */
  action?: { label: string; onClick: () => void };
  /** How long the message stays, in ms (sonner's default otherwise). */
  duration?: number;
};

export function showError(message: string, options?: AlertOptions): void {
  if (options) toast.error(message, options);
  else toast.error(message);
}

export function showSuccess(message: string): void {
  toast.success(message);
}

export function showInfo(message: string): void {
  toast.info(message);
}
